import { IconMessageChatbot } from '@tabler/icons-react';
import { useTranslations } from 'next-intl';
import { Button, Group, Text } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { ApplicationError } from '@/src/shared/errors';
import { translateWithFallback } from '@/src/shared/utils/i18n';

interface IRegisterSelfMedicationConversationTileProps {
  size?: 'sm' | 'md';
  createSelfMedicationConversation?: () => void;
  isCreatingSelfMedicationConversation?: boolean;
}

export function RegisterSelfMedicationConversationTile({
  size = 'md',
  createSelfMedicationConversation,
  isCreatingSelfMedicationConversation,
}: IRegisterSelfMedicationConversationTileProps) {
  const apiErrorTranslator = useTranslations('api-errors');
  const commonErrorTranslator = useTranslations('common-errors');
  const isNormalSize = size === 'md';

  const onClick = async () => {
    try {
      createSelfMedicationConversation?.();
    } catch (error) {
      if (error instanceof ApplicationError) {
        notifications.show({
          title: error.name,
          message: translateWithFallback(
            error.name,
            apiErrorTranslator,
            commonErrorTranslator
          ),
          color: 'red',
        });
        return;
      }

      throw error;
    }
  };

  return (
    <Button
      size="compact-md"
      variant="transparent"
      onClick={onClick}
      loading={isCreatingSelfMedicationConversation}
    >
      <Group gap={isNormalSize ? 'sm' : 'xs'}>
        <IconMessageChatbot size={isNormalSize ? 18 : 16} />
        <Text fz={isNormalSize ? 'sm' : 'xs'} fw={600}>
          Daftar Swamedikasi
        </Text>
      </Group>
    </Button>
  );
}
